import { AsyncComponentRender } from '@components/AsyncComponent';
import { createTabs } from '@packages/tabs';

export const TABS = createTabs([
    ['templates', 'Templates', AsyncComponentRender(() => import('./Templates'))],
    ['file-library', 'File Library', AsyncComponentRender(() => import('./FileLibrary'))],
]);
